// Маппинг русских названий стран на флаги эмодзи
export const countriesMapping = {
  'Афганистан': '🇦🇫',
  'Албания': '🇦🇱',
  'Алжир': '🇩🇿',
  'Андорра': '🇦🇩',
  'Ангола': '🇦🇴',
  'Антарктида': '🇦🇶',
  'Аргентина': '🇦🇷',
  'Армения': '🇦🇲',
  'Австралия': '🇦🇺',
  'Австрия': '🇦🇹',
  'Азербайджан': '🇦🇿',
  'Багамы': '🇧🇸',
  'Бахрейн': '🇧🇭',
  'Бангладеш': '🇧🇩',
  'Барбадос': '🇧🇧',
  'Беларусь': '🇧🇾',
  'Бельгия': '🇧🇪',
  'Белиз': '🇧🇿',
  'Бенин': '🇧🇯',
  'Бермуды': '🇧🇲',
  'Бутан': '🇧🇹',
  'Боливия': '🇧🇴',
  'Босния и Герцеговина': '🇧🇦',
  'Ботсвана': '🇧🇼',
  'Бразилия': '🇧🇷',
  'Бруней': '🇧🇳',
  'Болгария': '🇧🇬',
  'Буркина-Фасо': '🇧🇫',
  'Бурунди': '🇧🇮',
  'Камбоджа': '🇰🇭',
  'Камерун': '🇨🇲',
  'Канада': '🇨🇦',
  'Кабо-Верде': '🇨🇻',
  'Центральноафриканская Республика': '🇨🇫',
  'Чад': '🇹🇩',
  'Чили': '🇨🇱',
  'Китай': '🇨🇳',
  'Колумбия': '🇨🇴',
  'Коморы': '🇰🇲',
  'Конго': '🇨🇬',
  'Коста-Рика': '🇨🇷',
  'Хорватия': '🇭🇷',
  'Куба': '🇨🇺',
  'Кипр': '🇨🇾',
  'Чехия': '🇨🇿',
  'Дания': '🇩🇰',
  'Джибути': '🇩🇯',
  'Доминика': '🇩🇲',
  'Доминиканская Республика': '🇩🇴',
  'Эквадор': '🇪🇨',
  'Египет': '🇪🇬',
  'Сальвадор': '🇸🇻',
  'Экваториальная Гвинея': '🇬🇶',
  'Эритрея': '🇪🇷',
  'Эстония': '🇪🇪',
  'Эфиопия': '🇪🇹',
  'Фиджи': '🇫🇯',
  'Финляндия': '🇫🇮',
  'Франция': '🇫🇷',
  'Габон': '🇬🇦',
  'Гамбия': '🇬🇲',
  'Грузия': '🇬🇪',
  'Германия': '🇩🇪',
  'Гана': '🇬🇭',
  'Греция': '🇬🇷',
  'Гренада': '🇬🇩',
  'Гватемала': '🇬🇹',
  'Гвинея': '🇬🇳',
  'Гвинея-Бисау': '🇬🇼',
  'Гайана': '🇬🇾',
  'Гаити': '🇭🇹',
  'Гондурас': '🇭🇳',
  'Венгрия': '🇭🇺',
  'Исландия': '🇮🇸',
  'Индия': '🇮🇳',
  'Индонезия': '🇮🇩',
  'Иран': '🇮🇷',
  'Ирак': '🇮🇶',
  'Ирландия': '🇮🇪',
  'Израиль': '🇮🇱',
  'Италия': '🇮🇹',
  'Ямайка': '🇯🇲',
  'Япония': '🇯🇵',
  'Иордания': '🇯🇴',
  'Казахстан': '🇰🇿',
  'Кения': '🇰🇪',
  'Кирибати': '🇰🇮',
  'Косово': '🇽🇰',
  'Кувейт': '🇰🇼',
  'Кыргызстан': '🇰🇬',
  'Лаос': '🇱🇦',
  'Латвия': '🇱🇻',
  'Ливан': '🇱🇧',
  'Лесото': '🇱🇸',
  'Либерия': '🇱🇷',
  'Ливия': '🇱🇾',
  'Лихтенштейн': '🇱🇮',
  'Литва': '🇱🇹',
  'Люксембург': '🇱🇺',
  'Мадагаскар': '🇲🇬',
  'Малави': '🇲🇼',
  'Малайзия': '🇲🇾',
  'Мальдивы': '🇲🇻',
  'Мали': '🇲🇱',
  'Мальта': '🇲🇹',
  'Маршалловы Острова': '🇲🇭',
  'Мавритания': '🇲🇷',
  'Маврикий': '🇲🇺',
  'Мексика': '🇲🇽',
  'Микронезия': '🇫🇲',
  'Молдова': '🇲🇩',
  'Монако': '🇲🇨',
  'Монголия': '🇲🇳',
  'Черногория': '🇲🇪',
  'Марокко': '🇲🇦',
  'Мозамбик': '🇲🇿',
  'Мьянма': '🇲🇲',
  'Намибия': '🇳🇦',
  'Науру': '🇳🇷',
  'Непал': '🇳🇵',
  'Нидерланды': '🇳🇱',
  'Новая Зеландия': '🇳🇿',
  'Никарагуа': '🇳🇮',
  'Нигер': '🇳🇪',
  'Нигерия': '🇳🇬',
  'Северная Корея': '🇰🇵',
  'Северная Македония': '🇲🇰',
  'Норвегия': '🇳🇴',
  'Оман': '🇴🇲',
  'Пакистан': '🇵🇰',
  'Палау': '🇵🇼',
  'Палестина': '🇵🇸',
  'Панама': '🇵🇦',
  'Папуа - Новая Гвинея': '🇵🇬',
  'Парагвай': '🇵🇾',
  'Перу': '🇵🇪',
  'Филиппины': '🇵🇭',
  'Польша': '🇵🇱',
  'Португалия': '🇵🇹',
  'Катар': '🇶🇦',
  'Румыния': '🇷🇴',
  'Россия': '🇷🇺',
  'Руанда': '🇷🇼',
  'Саудовская Аравия': '🇸🇦',
  'Сенегал': '🇸🇳',
  'Сербия': '🇷🇸',
  'Сейшелы': '🇸🇨',
  'Сьерра-Леоне': '🇸🇱',
  'Сингапур': '🇸🇬',
  'Словакия': '🇸🇰',
  'Словения': '🇸🇮',
  'Соломоновы Острова': '🇸🇧',
  'Сомали': '🇸🇴',
  'Южная Африка': '🇿🇦',
  'Южная Корея': '🇰🇷',
  'Южный Судан': '🇸🇸',
  'Испания': '🇪🇸',
  'Шри-Ланка': '🇱🇰',
  'Судан': '🇸🇩',
  'Суринам': '🇸🇷',
  'Швеция': '🇸🇪',
  'Швейцария': '🇨🇭',
  'Сирия': '🇸🇾',
  'Тайвань': '🇹🇼',
  'Таджикистан': '🇹🇯',
  'Танзания': '🇹🇿',
  'Таиланд': '🇹🇭',
  'Того': '🇹🇬',
  'Тонга': '🇹🇴',
  'Тринидад и Тобаго': '🇹🇹',
  'Тунис': '🇹🇳',
  'Турция': '🇹🇷',
  'Туркменистан': '🇹🇲',
  'Тувалу': '🇹🇻',
  'Уганда': '🇺🇬',
  'Украина': '🇺🇦',
  'Объединенные Арабские Эмираты': '🇦🇪',
  'Великобритания': '🇬🇧',
  'Соединенные Штаты': '🇺🇸',
  'США': '🇺🇸',
  'Уругвай': '🇺🇾',
  'Узбекистан': '🇺🇿',
  'Вануату': '🇻🇺',
  'Ватикан': '🇻🇦',
  'Венесуэла': '🇻🇪',
  'Вьетнам': '🇻🇳',
  'Йемен': '🇾🇪',
  'Замбия': '🇿🇲',
  'Зимбабве': '🇿🇼',
  // Альтернативные названия
  'Российская Федерация': '🇷🇺',
  'Соединенное Королевство': '🇬🇧',
  'Соединенные Штаты Америки': '🇺🇸',
  'США Америка': '🇺🇸',
  'Америка': '🇺🇸',
  'Великобритания и Северная Ирландия': '🇬🇧',
  'Англия': '🇬🇧',
  'Корея': '🇰🇷',
  'Южная Корея': '🇰🇷',
  'КНДР': '🇰🇵',
  'КНР': '🇨🇳',
  'Китайская Народная Республика': '🇨🇳',
  'Китайская Республика': '🇹🇼',
  'Тайвань': '🇹🇼',
  'Гонконг': '🇭🇰',
  'Макао': '🇲🇴',
  'Палестинские территории': '🇵🇸',
  'Палестина': '🇵🇸',
  // Дополнительные варианты написания
  'Белоруссия': '🇧🇾',
  'Македония': '🇲🇰',
  'Молдавия': '🇲🇩',
  'Бирма': '🇲🇲',
  'Восточный Тимор': '🇹🇱',
  'Тимор-Лешти': '🇹🇱',
  'Свазиленд': '🇸🇿',
  'Босния': '🇧🇦',
  'Герцеговина': '🇧🇦',
  'Сербия и Черногория': '🇷🇸',
  'Югославия': '🇷🇸',
  'Чехословакия': '🇨🇿',
  'СССР': '🇷🇺',
  'Советский Союз': '🇷🇺',
};

// Функция для поиска флага по названию страны (с учетом различных вариантов написания)
export const getCountryFlag = (countryName) => {
  if (!countryName) return '🌍';
  
  const normalized = countryName.trim();
  
  // Прямое совпадение
  if (countriesMapping[normalized]) {
    return countriesMapping[normalized];
  }
  
  // Поиск без учета регистра
  const lowerNormalized = normalized.toLowerCase();
  for (const [key, flag] of Object.entries(countriesMapping)) {
    if (key.toLowerCase() === lowerNormalized) {
      return flag;
    }
  }
  
  // Поиск по частичному совпадению
  for (const [key, flag] of Object.entries(countriesMapping)) {
    if (key.toLowerCase().includes(lowerNormalized) || lowerNormalized.includes(key.toLowerCase())) {
      return flag;
    }
  }
  
  return '🌍'; // Флаг по умолчанию
};

// Получить список всех стран для автодополнения
export const getAllCountryNames = () => {
  return Object.keys(countriesMapping);
};

